import { styled } from 'parkdepot-shared/theme'

export const OrderListContainer = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale700
}))

export const MultipleOrdersText = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    color: $theme.colors.mono400
}))

export const SpinnerContainer = styled('div', ({ $theme }) => ({
    padding: `0 ${$theme.sizing.scale700}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))
